import React from "react";
import ReactDOM from "react-dom";
import { applyMiddleware, createStore, compose } from 'redux';
import { Provider } from 'react-redux';

import reducer from './reducers/r.index';
import initialState from './store';

import App from './components/app';

// middlewares
import thunk from 'redux-thunk';

const middleware = [thunk];

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducer, initialState, composeEnhancers(applyMiddleware(...middleware)));

ReactDOM.render(<Provider store={store}><App /></Provider>, document.getElementById("app"));

if (process.env.NODE_ENV === "development") 
    module.hot.accept();